<template lang="html">
  <div class="bear">
    <div class="bear-container">
      <div class="face">
        <div class="eye left"></div>
        <div class="eye right"></div>
        <div class="snout">
            <div class="nose"></div>
            <div class="noseline"></div>
            <div class="mouth"></div>
        </div>
      </div>
      <div class="ear right">
        <div class="innerear"></div>
      </div>
      <div class="ear left">
        <div class="innerear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.bear-container{
  width:60px;
  height:60px;
  background: transparent;
  margin: auto;
  position: relative;
}

.face{
  position: absolute;
  z-index: 10;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: brown;
  top: 5px;
  left: 5px;
}

.eye{
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: black;
  position: absolute;
  top: 21px;
  left: 18px;
}

.eye.right{
  transform: translateX(20px);
}

.snout{
  position: absolute;
  left: 20px;
  top: 24px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: salmon;
}

.nose{
  position: absolute;
  top: 4px;
  left: 8px;
  width: 7px;
  height: 4px;
  background-color: black;
  border-radius: 80%;
}

.noseline{
  position: absolute;
  width: 1px;
  height: 7px;
  background: black;
  top: 5px;
  left: 11px;
}

.mouth{
  position: absolute;
  top: 12px;
  left: 8px;
  width: 6px;
  height: 1px;
  background-color: black;
}

.ear{
  position: absolute;
  top: 5px;
  left: 3px;
  width: 20px;
  height: 20px;
  background-color: brown;
  border-radius: 50%;
}

.ear.right{
  transform: translateX(34px);
}

.innerear{
  position: absolute;
  z-index: 9;
  top: 2px;
  left: 2px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: pink;

}

</style>
